/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/order_source';
import '../../../../connect/v2/resources/error';
import '../../resources/order';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "LineItemAttributes": {
                    "fields": {
                      "variantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "quantity": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AddOnLineItemAttributes": {
                    "fields": {
                      "variantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateLineItemQuantityRequest": {
                    "fields": {
                      "action": {
                        "type": "squareup.solidshop.v2.service.UpdateLineItemQuantityRequest.Action",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lineItemAttributes": {
                        "type": "squareup.solidshop.v2.service.LineItemAttributes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "addOnLineItemAttributes": {
                        "type": "squareup.solidshop.v2.service.AddOnLineItemAttributes",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "source": {
                        "type": "squareup.solidshop.v2.common.OrderSource",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Action": {
                        "values": {
                          "ADD": 1,
                          "SUBTRACT": 2,
                          "OVERWRITE": 3
                        }
                      }
                    }
                  },
                  "UpdateLineItemQuantityResponse": {
                    "fields": {
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "order": {
                        "type": "squareup.solidshop.v2.resources.Order",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE LineItemAttributes @ squareup/solidshop/v2/service/orders/update_line_item_quantity.proto at 12:1
 */
export const LineItemAttributes = $root.lookupType('squareup.solidshop.v2.service.LineItemAttributes');
fixType(LineItemAttributes);
Builder.createAndAttachToType(LineItemAttributes);
/**
 * SOURCE AddOnLineItemAttributes @ squareup/solidshop/v2/service/orders/update_line_item_quantity.proto at 23:1
 */
export const AddOnLineItemAttributes = $root.lookupType('squareup.solidshop.v2.service.AddOnLineItemAttributes');
fixType(AddOnLineItemAttributes);
Builder.createAndAttachToType(AddOnLineItemAttributes);
/**
 * SOURCE UpdateLineItemQuantityRequest @ squareup/solidshop/v2/service/orders/update_line_item_quantity.proto at 31:1
 */
export const UpdateLineItemQuantityRequest = $root.lookupType('squareup.solidshop.v2.service.UpdateLineItemQuantityRequest');
fixType(UpdateLineItemQuantityRequest);
Builder.createAndAttachToType(UpdateLineItemQuantityRequest);
/**
 * SOURCE Action @ squareup/solidshop/v2/service/orders/update_line_item_quantity.proto at 32:3
 */
UpdateLineItemQuantityRequest.Action = $root.lookupEnum('squareup.solidshop.v2.service.UpdateLineItemQuantityRequest.Action').values;
/**
 * SOURCE UpdateLineItemQuantityResponse @ squareup/solidshop/v2/service/orders/update_line_item_quantity.proto at 59:1
 */
export const UpdateLineItemQuantityResponse = $root.lookupType('squareup.solidshop.v2.service.UpdateLineItemQuantityResponse');
fixType(UpdateLineItemQuantityResponse);
Builder.createAndAttachToType(UpdateLineItemQuantityResponse);
